/**
=========================================================
* Exam Course Content
* Final assessment exam content
=========================================================
*/

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ExamCourse() {
  return (
    <MDBox>
      <MDTypography variant="h6" color="white" mb={2}>
        Exam
      </MDTypography>
      <MDTypography variant="body2" color="white" opacity={0.8}>
        Exam content will be displayed here.
      </MDTypography>
    </MDBox>
  );
}

export default ExamCourse;
